module.exports = __webpack_public_path__ + "static/media/linkedin.51c819f1.png";